<template>
  <div class="work-time-edit-page">
    <Button type="primary" icon="ios-arrow-back" @click="back">{{$t("system.workTime.Return_to_workTime_list")}}</Button>
    <Card class="edit-card">
        <div style="text-align:center">
          <h4>{{title}}</h4>
          <Form class="edit-form" :label-width="100">
            <FormItem :label="$t('system.workTime.name')">
              <Input class="info" v-model="name" :placeholder="$t('system.workTime.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('system.workTime.startTime')">
              <TimePicker @on-change="startTimeChange" :value="startTime" format="HH:mm" :placeholder="$t('system.workTime.please_choose')" class="info"></TimePicker>
            </FormItem>
            <FormItem :label="$t('system.workTime.endTime')">
              <TimePicker @on-change="endTimeChange" :value="endTime" format="HH:mm" :placeholder="$t('system.workTime.please_choose')" class="info"></TimePicker>
            </FormItem>
            <hr>
            <div class="save-btn"><Button type="primary" @click="save()">{{$t("system.workTime.save")}}</Button></div>
          </Form>
        </div>
    </Card>
  </div>
</template>
<script>
import {Api} from '@/api'
export default {
  name: 'WorkTimeEdit',
  data () {
    return {
      id: 0,
      name: '',
      startTime: '',
      endTime: ''
    }
  },
  computed: {
    title () {
      return this.id === 0 ? this.$t('system.workTime.New_workTime') : this.$t('system.workTime.edit_workTime')
    }
  },
  methods: {
    back () {
      this.$router.back()
    },
    save () {
      let workTime = {
        id: this.id,
        name: this.name,
        startTime: this.startTime,
        endTime: this.endTime
      }
      Api.workTime.save(workTime).then(() => {
        this.$router.push({'name': 'WorkTime'})
      })
    },
    startTimeChange (v) {
      this.startTime = v
    },
    endTimeChange (v) {
      this.endTime = v
    }
  },
  beforeRouteEnter (to, from, next) {
    let id = Number(to.params.id)
    if (id !== 0) {
      Api.workTime.get(id).then(res => {
        next(vm => {
          let wt = res.workTime
          vm.id = wt.id
          vm.name = wt.name
          vm.startTime = wt.startTime
          vm.endTime = wt.endTime
        })
      })
    } else {
      next()
    }
  }
}
</script>
<style scoped>
  .work-time-edit-page {
    padding: 10px;
  }
  .edit-card {
    margin-top: 20px
  }
  .edit-form {
    padding: 20px 0px;
    text-align: left;
  }
  .edit-form .info {
    width: 33.33333%
  }
  hr {
    background-color: #dbdbdb;
    border: none;
    display: block;
    height: 1px;
    margin: 1.5rem 0;
  }
  .save-btn {
    text-align: left;
  }
</style>





// WEBPACK FOOTER //
// Edit.vue?7227a432